export default "__VITE_ASSET__CbTDMvtg__"